<template>
<div v-can="'Read_Supplier'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h1 class="text-left">{{$tc('general.supplier', 2)}}</h1>
        <MainGrid gridTitle="Suppliers" objectNodeName="entityModels" endpoint="supplier" :gridColumns="columns" :filter="filter" formUrl="/supplier" :queryByFilter="true" :customOrderBy="true" deletedataToDisplay="supplierName" :deleteAssociatedData="$store.state.supplier.associatedData"></MainGrid>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import MainGrid from '../components/MainGrid'

export default {
  name: 'Suppliers',
  components: {
    MainGrid
  },
  data() {
    return {
      title: 'Suppliers',
      columns: [
        {
          label: this.$t('supplier.supplierName'),
          key: "supplierName",
          sortable: true,
          initial_sort: true  
        },
        {
          label: this.$t('distributor.distributorName'),
          key: "distributor.0.distributorName",
          sortable: true,
        },
        {
          label: this.$t('contact.firstname'),
          key: "contact.0.firstName",
          sortable: true,
        },
        {
          label: this.$t('contact.lastName'),
          key: "contact.0.lastName",
          sortable: true,
        },
        {
          key: "actionButtons",
          label: "",
        }
      ],
      filter: [{
        method: "findBySupplierDistributorContact",
        params: ["searchValue"]
      }]
    }
  }
}
</script>

<style>
.btn-icon{
  cursor: pointer;
  margin: 0px 5px;
}

</style>
